module.exports = __webpack_public_path__ + "img/button_icon_particular.0752ee5.svg";